import { translate } from 'utils/translation';

export const programHeader = (index, title, backgroundImage) => ({
  index: index || 0,
  sectionType: 'PROGRAM_HEADER',
  format: null,
  title: title || translate('common.programTitle'),
  backgroundImage: backgroundImage || null,
  elements: null
});